import { api } from './api';

export interface WellStatus {
  _id: string;
  name: string;
  slug: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateWellStatusData {
  name: string;
}

export interface UpdateWellStatusData {
  name: string;
}

interface WellStatusListResponse {
  message: string;
  data: {
    result: WellStatus[];
    totalCount: number;
    currentPage: number;
    totalPages: number;
    previousPage: null | number;
    nextPage: null | number;
  };
  error: boolean;
}

interface WellStatusResponse {
  message: string;
  data: WellStatus;
  error: boolean;
}

export const wellStatusService = {
  async getAll(page = 1, limit = 100): Promise<WellStatus[]> {
    const response = await api.get<WellStatusListResponse>(
      `/well-status?page=${page}&limit=${limit}`
    );
    const data = response.data.data;
    if (Array.isArray(data)) return data;
    return data.result ?? [];
  },

  async getById(id: string): Promise<WellStatus> {
    const response = await api.get<WellStatusResponse>(`/well-status/${id}`);
    return response.data.data;
  },

  async create(data: CreateWellStatusData): Promise<WellStatus> {
    const response = await api.post<WellStatusResponse>('/well-status', data);
    return response.data.data;
  },

  async update(id: string, data: UpdateWellStatusData): Promise<WellStatus> {
    const response = await api.put<WellStatusResponse>(`/well-status/${id}`, data);
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/well-status/${id}`);
  },
};
